var _linearGradient, _clipPath, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatformIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 619,
    viewBox: "0 0 619 619",
    width: 619,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 13.929,
    x2: 605.386,
    y1: 605.265,
    y2: 13.8068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30796c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    stopColor: "#44aca6"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124 124h371.528v371.394h-371.528z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m539.777 619h3.711c38.715 0 70.522-28.997 74.976-66.508l.536-251.295c-4.401-167.094-141.26-301.197-309.445-301.197-170.963 0-309.555 138.568-309.555 309.5 0 169.103 135.642 306.578 304.077 309.5z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.334 125.895h-197.138c-47.109 0-85.3 38.176-85.3 85.269v197.066c0 47.093 38.191 85.269 85.3 85.269h197.138c47.109 0 85.299-38.176 85.299-85.269v-197.066c0-47.093-38.19-85.269-85.299-85.269z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m211.195 130.316c-44.667 0-80.876 36.197-80.876 80.848v197.066c0 44.651 36.209 80.848 80.876 80.848h197.138c44.667 0 80.877-36.197 80.877-80.848v-197.066c0-44.651-36.21-80.848-80.877-80.848zm-89.722 80.848c0-49.535 40.17-89.69 89.722-89.69h197.138c49.552 0 89.722 40.155 89.722 89.69v197.066c0 49.535-40.17 89.69-89.722 89.69h-197.138c-49.552 0-89.722-40.155-89.722-89.69z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.329 384.62h-8.65v-115.547h8.65zm-4.448-143.871c-3.648 0-6.664-2.893-6.664-6.539 0-3.755 3.001-6.662 6.664-6.662 3.756 0 6.742 2.892 6.742 6.662 0 3.646-2.986 6.539-6.742 6.539z",
    fill: "#44aaa4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.345 386.875c-42.295 0-69.015-30.788-69.015-79.729 0-48.696 26.843-79.605 69.015-79.605s69 30.911 69 79.605c0 48.943-26.72 79.729-69 79.729zm0-151.381c-36.815 0-60.318 27.786-60.318 71.651 0 43.896 23.611 71.79 60.318 71.79 36.816 0 60.318-27.894 60.318-71.79 0-43.88-23.502-71.651-60.318-71.651z",
    fill: "#44aaa4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.94 386.875c-31.753 0-54.516-17.924-55.809-43.557h8.481c1.292 21.018 21.04 35.725 47.974 35.725 26.288 0 44.635-14.924 44.635-35.079 0-16.217-10.944-25.541-36.909-32.08l-18.346-4.508c-28.644-7.309-41.649-18.894-41.649-38.296 0-24.14 22.547-41.526 50.776-41.526 29.182 0 50.975 17.171 51.946 39.912h-8.481c-1.185-18.555-19.316-32.08-43.681-32.08-23.302 0-41.865 13.955-41.865 33.478 0 15.463 11.374 24.357 36.262 30.572l17.284 4.4c29.936 7.401 43.357 18.894 43.357 39.48 0 25.632-21.564 43.557-53.978 43.557z",
    fill: "#44aaa4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformIos);
export default __webpack_public_path__ + "static/media/platform-ios.80c4e718b8579d36269522a7f48ff150.svg";
export { ForwardRef as ReactComponent };